<template>
  <div class="stay-connected animatedBox">
    <div class="container fluid">
      <div class="card p-1">
        <fd-table
          :componentTitle="'General News'"
          :routerButton="routerButton"
          :tableButton="actionButton"
          :indexed="true"
          :plugin="{
            search: [1, 2],
          }"
          :searchBarTitle="'Search from title...'"
          :getFunction="getAllNews"
        ></fd-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "stay-connected",
  data() {
    return {
      routerButton: [
        {
          title: "Add News",
          class: "add",
          routerLink: "/stay-connected/add",
        },
      ],
      actionButton: [
        {
          title: "Edit",
          class: "edit",
          routerLink: "/stay-connected/edit",
        },
        {
          title: "Delete",
          class: "delete",
          routerLink: null,
          onclick: async (id) => {
            const c = confirm(
              "Are you sure to delete this news? You cannot undo after this."
            );

            if (c) {
              return this.removeGeneralNews(id);
            }
          },
          getData: true,
        },
      ],
    };
  },
  methods: {
    async getAllNews(keyword, currentPage, perPage, isLoading) {
      const request = await this.$store.dispatch(
        "generalNews/getAllGeneralNews",
        {
          keyword: keyword,
          currentPage: currentPage,
          perPage: perPage,
          isLoading: isLoading,
        }
      );

      return request;
    },
    async removeGeneralNews(id) {
      const request = await this.$store.dispatch(
        "generalNews/deleteGeneralNews",
        id
      );

      return request;
    },
  },
};
</script>

<style>
.stay-connected {
}
</style>